import { render, staticRenderFns } from "./UnblockContactModal.vue?vue&type=template&id=21443a7e&"
import script from "./UnblockContactModal.vue?vue&type=script&lang=js&"
export * from "./UnblockContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports